import { types } from "../types/types";

export const SelectedDetailsContractor = (details) => ({
    type: types.ContractorSelectedDetails,
    payload: details,
  });

